<template>
<div class="chapter">
<div class="inner_page">
<h2 class="toc-title">Table of Contents</h2>
<p class="toc-chap"><a href="#/xhtml/fm01"><span class="tno">Prologue</span> Home, But Not Home (Homecoming Part 1)</a></p>
<p class="toc-chap"><a href="#/xhtml/chap01"><span class="tno">Chapter One</span> Dancing in the Streets</a></p>
<p class="toc-chap"><span href="#/xhtml/chap02" title="Link target outside of Sample"><span class="tno">Chapter Two</span> The Thunder of War</span></p>
<p class="toc-chap"><span href="#/xhtml/chap03" title="Link target outside of Sample"><span class="tno">Chapter Three</span> Through the Jungle</span></p>
<p class="toc-chap"><span href="#/xhtml/chap04" title="Link target outside of Sample"><span class="tno">Chapter Four</span> Banana Sledding in Kaziba</span></p>
<p class="toc-chap"><span href="#/xhtml/chap05" title="Link target outside of Sample"><span class="tno">Chapter Five</span> City in Chaos</span></p>
<p class="toc-chap"><span href="#/xhtml/chap06" title="Link target outside of Sample"><span class="tno">Chapter Six</span> Internally Displaced</span></p>
<p class="toc-chap"><span href="#/xhtml/chap07" title="Link target outside of Sample"><span class="tno">Chapter Seven</span> “We Did Not Come Here to Die”</span></p>
<p class="toc-chap"><span href="#/xhtml/chap08" title="Link target outside of Sample"><span class="tno">Chapter Eight</span> Waiting Up for Mom</span></p>
<p class="toc-chap"><span href="#/xhtml/chap09" title="Link target outside of Sample"><span class="tno">Chapter Nine</span> The Congo Boys</span></p>
<p class="toc-chap"><span href="#/xhtml/chap10" title="Link target outside of Sample"><span class="tno">Chapter Ten</span> Waiting for Our Angel</span></p>
<p class="toc-chap"><span href="#/xhtml/chap11" title="Link target outside of Sample"><span class="tno">Chapter Eleven</span> The Ntiboneras Arrive</span></p>
<p class="toc-chap"><span href="#/xhtml/chap12" title="Link target outside of Sample"><span class="tno">Chapter Twelve</span> Looking Back</span></p>
<p class="toc-chap"><span href="#/xhtml/chap13" title="Link target outside of Sample"><span class="tno">Chapter Thirteen</span> Fresh Wounds (Homecoming Part II)</span></p>
<p class="toc-chap"><span href="#/xhtml/chap14" title="Link target outside of Sample"><span class="tno">Chapter Fourteen</span> A House Full of Shoes</span></p>
<p class="toc-chap"><span href="#/xhtml/chap15" title="Link target outside of Sample"><span class="tno">Chapter Fifteen</span> Kick’n It for a Cause</span></p>
<p class="toc-chap"><span href="#/xhtml/chap16" title="Link target outside of Sample"><span class="tno">Chapter Sixteen</span> Empty Hands</span></p>
<p class="toc-chap"><span href="#/xhtml/chap17" title="Link target outside of Sample"><span class="tno">Chapter Seventeen</span> Father to the Fatherless</span></p>
<p class="toc-chap"><span href="#/xhtml/chap18" title="Link target outside of Sample"><span class="tno">Chapter Eighteen</span> Shoeprints</span></p>
<p class="toc-chap"><span href="#/xhtml/bm01" title="Link target outside of Sample"><span class="tno">Afterword</span> Forgotten People</span></p>
<p class="toc-chapt"><span href="#/xhtml/bm03" title="Link target outside of Sample">Acknowledgements</span></p>
<p class="toc-chap"><span href="#/xhtml/bm04" title="Link target outside of Sample">About the Authors</span></p>
<p class="toc-chap"><span href="#/xhtml/bm05" title="Link target outside of Sample">Endnotes</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?4a033c80